/** Evento document para cerrar un popup por id (coordinación entre instancias). */
export const POPUP_CLOSE_EVENT = 'close-popup' as const;

const openPopups = new Set<string>();

function getPopupHostElement(popupId: string): Element | null {
  if (typeof document === 'undefined') {
    return null;
  }
  return document.querySelector(`[data-popup-id="${CSS.escape(popupId)}"]`);
}

/**
 * Cierra el resto de popups registrados vía evento global (un solo panel abierto a la vez),
 * salvo ancestros que **contengan** el trigger del popup que se abre (popups anidados).
 */
export function closeOtherPopups(excludeId: string, openingTrigger?: Element | null): void {
  openPopups.forEach((id) => {
    if (id === excludeId) {
      return;
    }
    if (openingTrigger) {
      const host = getPopupHostElement(id);
      if (host?.contains(openingTrigger)) {
        return;
      }
    }
    document.dispatchEvent(new CustomEvent(POPUP_CLOSE_EVENT, { detail: { id } }));
  });
}

export function trackPopupOpen(id: string): void {
  openPopups.add(id);
}

export function trackPopupClose(id: string): void {
  openPopups.delete(id);
}
